var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedBagIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.18273 12.4904C2.88273 13.3333 4.18473 13.3333 6.78989 13.3333H7.20989C9.81506 13.3333 11.1176 13.3333 11.8176 12.4904M2.18273 12.4904C1.48273 11.6469 1.72306 10.3671 2.20315 7.80625C2.5444 5.98625 2.71473 5.07567 3.36281 4.53783M11.8176 12.4904C12.5176 11.6469 12.2773 10.3671 11.7972 7.80625C11.456 5.98625 11.2851 5.07567 10.637 4.53783M10.637 4.53783C9.98948 4 9.06256 4 7.21048 4H6.78931C4.93723 4 4.0109 4 3.36281 4.53783",
    stroke: "#E77B7B",
    strokeWidth: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75033 6.91406L9.33366 10.4141M5.25033 6.91406L4.66699 10.4141M5.25033 3.9974V3.41406C5.25033 2.94993 5.4347 2.50481 5.76289 2.17663C6.09108 1.84844 6.5362 1.66406 7.00033 1.66406C7.46445 1.66406 7.90957 1.84844 8.23776 2.17663C8.56595 2.50481 8.75033 2.94993 8.75033 3.41406V3.9974",
    stroke: "#E77B7B",
    strokeWidth: 0.75,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedBagIcon);
export default __webpack_public_path__ + "static/media/red_bag_icon.688af4a11bb2a09a24b1522b5a241ec2.svg";
export { ForwardRef as ReactComponent };